﻿export class BrokenPhotoRequest {
    public URL : string;
    public MLSid : string;
    public PDID : string;
}